export const SmallBankAccountIcon = ({
  color = "#784EFF",
}: {
  color?: string;
}) => {
  return (
    <svg
      width="25"
      height="25"
      viewBox="0 0 25 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_110_16384)">
        <path
          opacity="0.2"
          d="M2.76611 9.0625H22.2661L12.5161 3.0625L2.76611 9.0625Z"
          fill={color}
        />
        <path
          d="M2.76611 9.0625H22.2661L12.5161 3.0625L2.76611 9.0625Z"
          stroke={color}
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M5.76611 9.0625V16.5625"
          stroke={color}
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M10.2661 9.0625V16.5625"
          stroke={color}
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M14.7661 9.0625V16.5625"
          stroke={color}
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M19.2661 9.0625V16.5625"
          stroke={color}
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M3.51611 16.5625H21.5161"
          stroke={color}
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M2.01611 19.5625H23.0161"
          stroke={color}
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_110_16384">
          <rect
            width="24"
            height="24"
            fill="white"
            transform="translate(0.516113 0.0625)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};
